/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// redux
import { useSelector, useDispatch, batch } from 'react-redux';
import { toggleSidebar, lockSidebar } from '../../../../../state/slices/app';
// material
import { Icon } from '@insticator/insticator-ui';
// styles
import injectSheet from 'react-jss';
import styles from './asidetoggle_styles';



/* ========== ~~~~~~~~~~ ASIDE TOGGLE ~~~~~~~~~~ ========== */
const AsideToggle = injectSheet(styles)((props) => {
	const dispatch = useDispatch();
	const sidebarOpen = useSelector(state => state.app.sidebarOpen);
	const sidebarLocked = useSelector(state => state.app.sidebarLocked);
	const handleIndicatorDirection = () => sidebarOpen ? 'left' : 'right';
	const handleIndicatorClick = (e) => {
		batch(() => {
			dispatch(toggleSidebar(!sidebarOpen));
			dispatch(lockSidebar(!sidebarLocked));
		});
	};
	return (
		<div className={`${props.classes.asidetoggle} asidetoggle sidebarOpen-${sidebarOpen}`}>
			<Icon klass={`indicator`} name={`arrow-${handleIndicatorDirection()}`} animation={'none'} handleClick={handleIndicatorClick} />
		</div>
	);
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default AsideToggle;
